/*
 * This is intended to be the component used to render the list of previous
 * notes associated with a care event, i.e. diagnosis, surgery, etc.
 */

import React from 'react';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';
import NoteListGroup from './ListGroup';

const CareEventNoteListGroup = ({ title, notes }) => {
  return (<>
    <Label className="text-primary">{title}</Label>

    <NoteListGroup
      notes={notes}
      options={{
        includeAuthor: true,
        includeDuration: true,
        dateFormat: 'MM/DD/YYYY hh:mm A',
      }}
    />
  </>);
};

CareEventNoteListGroup.propTypes = {
  title: PropTypes.string,
  notes: PropTypes.arrayOf(PropTypes.shape()),
};

CareEventNoteListGroup.defaultProps = {
  title: 'Notes',
  notes: [],
};

export default CareEventNoteListGroup;
